const qaSkill = (name, color = "bg-cyan-200", textColor = "text-cyan-900") => ({
  name,
  color,
  textColor,
  darkBgColor: "dark:bg-cyan-700",
  darkTextColor: "dark:text-cyan-100",
});

const internships = [
  {
    company: "HYTEK VN Company",
    location: "Tan Binh, Ho Chi Minh",
    duration: "QA Tester / Frontend Engineer | 2022 - Present",
    mode: "On-Site",
    projects: [
      {
        name: "Day Sales - Sieu Thi",
        description:
          "Validated e-commerce flows including product listing, cart, checkout, order detail, responsive UI behavior, and regression checks after frontend changes.",
      },
      {
        name: "Days Shop - Ban Le",
        description:
          "Tested reusable Vue components, API-driven states, validation messages, and cross-device display issues while collaborating with backend and product teams.",
      },
    ],
    description:
      "Combined hands-on frontend development with QA ownership: requirement review, test case writing, defect reproduction, bug verification, and release support for web products used across desktop, tablet, and mobile.",
    skills: [
      qaSkill("Manual Testing", "bg-emerald-200", "text-emerald-900"),
      qaSkill("Regression Testing", "bg-indigo-200", "text-indigo-900"),
      qaSkill("Jira", "bg-blue-200", "text-blue-900"),
      qaSkill("Vue.js", "bg-yellow-200", "text-yellow-900"),
      qaSkill("REST APIs", "bg-sky-200", "text-sky-900"),
    ],
  },
  {
    company: "Backend / API Collaboration",
    location: "Ho Chi Minh",
    duration: "Backend Exposure | 1 Year",
    mode: "Product Team",
    projects: [
      {
        name: "API-driven Web Features",
        description:
          "Worked with REST API responses, JSON payloads, SQL-backed data, error states, and integration behavior between frontend and backend services.",
      },
    ],
    description:
      "This backend experience helps me test beyond the visible UI: checking data consistency, API contracts, request/response behavior, and edge cases that usually create production bugs.",
    skills: [
      qaSkill("API Testing", "bg-sky-200", "text-sky-900"),
      qaSkill("Postman", "bg-orange-200", "text-orange-900"),
      qaSkill("SQL", "bg-lime-200", "text-lime-900"),
      qaSkill("JSON", "bg-gray-200", "text-gray-900"),
    ],
  },
  {
    company: "Open Ideas / Game Projects",
    location: "Ho Chi Minh",
    duration: "Unity UI & Game Product Experience | 2024 - Present",
    mode: "On-Site",
    projects: [
      {
        name: "OhayHe - Japanese Language Learning",
        description:
          "Worked with interactive UI behavior, screen flow, and user-facing feedback where usability and defect visibility matter.",
      },
      {
        name: "Urban Building",
        description:
          "Supported game UI implementation and validated interaction states across different screen sizes and app contexts.",
      },
    ],
    description:
      "Game and learning-app experience strengthens my attention to interaction details, usability testing, visual defects, and release quality for user-facing products.",
    skills: [
      qaSkill("Usability Testing", "bg-purple-200", "text-purple-900"),
      qaSkill("Mobile UI", "bg-pink-200", "text-pink-900"),
      qaSkill("C#", "bg-blue-200", "text-blue-900"),
      qaSkill("Exploratory Testing", "bg-teal-200", "text-teal-900"),
    ],
  },
];

export default internships;
